import { GetCreditPanInformationResponse } from 'src/sdk-credit';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetCreditPanInformationModel } from './get-credit-pan-information.state';

/** StateDetailsActions */
const ACTION_SET = '[GetCreditPanInformation] set';
const ACTION_UPDATE = '[GetCreditPanInformation] update';
const ACTION_RESET = '[GetCreditPanInformation] reset';
const ACTION_FAIL = '[GetCreditPanInformation] fail';
const ACTION_CANCEL_REQUEST = '[GetCreditPanInformation] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetCreditPanInformation] set from api';
const ACTION_UPDATE_FROM_API = '[GetCreditPanInformation] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetCreditPanInformation = createAction(
  ACTION_SET,
  props<WithRequestId<GetCreditPanInformationModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetCreditPanInformation = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetCreditPanInformationModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetCreditPanInformation = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetCreditPanInformationRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetCreditPanInformation = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetCreditPanInformationFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetCreditPanInformationResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetCreditPanInformationFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetCreditPanInformationResponse>>()
);
